module.exports = __webpack_public_path__ + "img/open-envelope-clock.212c2e63.png";